export enum JobViewType {
  DEFAULT = "DEFAULT",
  PDF = "PDF"
}
